import {
  TestimonialCard as TestimonialCardComponent,
  TestimonialCardProps as TestimonialCardComponentProps,
} from "@kunduz/feature-landing-pages";
import { ComponentConfig } from "@measured/puck";

export interface TestimonialCardProps extends TestimonialCardComponentProps {}

const TestimonialCard = (props: TestimonialCardProps) => {
  return <TestimonialCardComponent {...props} />;
};

export const PuckTestimonialCard: ComponentConfig<TestimonialCardProps> = {
  label: "Testimonial Card",
  fields: {
    image: { type: "text", label: "Image URL" },
    video: { type: "text", label: "Video URL" },
    wistiaId: { type: "text", label: "Wistia ID" },
    title: { type: "text", label: "Title" },
    description: { type: "text", label: "Description" },
    studentName: { type: "text", label: "Student Name" },
    studentTitle: { type: "text", label: "Student Title" },
    style: {
      type: "object",
      label: "Options",
      objectFields: {
        maxWidth: { type: "text", label: "Max Width" },
      },
    },
  },
  defaultProps: {
    image: "",
    video: "",
    wistiaId: "",
    title:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Sunt sed, laudantium hic, cumque delectus ducimus ipsum culpa nisi voluptas itaque nulla consectetur necessitatibus illum nihil perspiciatis molestiae illo ipsam pariatur?",
    description:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Sunt sed, laudantium hic, cumque delectus ducimus ipsum culpa nisi voluptas itaque nulla consectetur necessitatibus illum nihil perspiciatis molestiae illo ipsam pariatur?",
    studentName:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Sunt sed, laudantium hic, cumque delectus ducimus ipsum culpa nisi voluptas itaque nulla consectetur necessitatibus illum nihil perspiciatis molestiae illo ipsam pariatur?",
    studentTitle:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Sunt sed, laudantium hic, cumque delectus ducimus ipsum culpa nisi voluptas itaque nulla consectetur necessitatibus illum nihil perspiciatis molestiae illo ipsam pariatur?",
  },
  render: (props) => <TestimonialCard {...props} />,
};
